import { Box, styled, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import moment from 'moment';
import useAppointments from '../../hooks/useAppointments';
import { useStore } from '../../store/context';

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: 5,
  marginTop: 0,
  marginBottom: 0,
  paddingTop: 0,
  paddingBottom: 0,
}));

const DashAppointments: FC = observer(() => {
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;
  const { allAppointments } = useAppointments(currentEstate);

  return (
    <Box sx={{ marginTop: 2 }}>
      <Box
        paddingBottom={2}
        paddingLeft={2}
        paddingRight={2}
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'secondary.light',
          borderRadius: '3px',
        }}
      >
        <Typography
          paddingTop={2}
          paddingBottom={2}
          color="secondary.main"
          fontSize={18}
          fontFamily="BrixSansBold"
          variant="body1"
        >
          Termine
        </Typography>
        {allAppointments?.length === 0 && (
          <Box
            width={1}
            height={1}
            p={2}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: 'red',
              borderRadius: '3px',
            }}
          >
            <Typography variant="body1" color="white" textAlign="center">
              Keine Termine vorhanden
            </Typography>
          </Box>
        )}
        {allAppointments?.map(appointment => (
          <Box
            sx={{ backgroundColor: 'red', borderRadius: '3px' }}
            padding={2}
            width={1}
            height={1}
            key={`${appointment.auftragstatus}${appointment.datum}${appointment.text}`}
          >
            <StyledText
              textAlign="center"
              sx={{
                color: 'white',
                fontWeight: 'fontWeightBold',
                overflowWrap: 'break-word',
                paddingBottom: 1,
                fontSize: 15,
              }}
            >
              {appointment.text}
            </StyledText>
            <StyledText
              textAlign="center"
              sx={{
                color: 'white',
                overflowWrap: 'break-word',
                paddingBottom: 1,
                fontSize: 14,
              }}
            >
              {moment(appointment.datum).format('DD.MM.YYYY')}
            </StyledText>
          </Box>
        ))}
      </Box>
    </Box>
  );
});

export default DashAppointments;
